import createComponentQuickSearchComponent from './components/quick_search/main.js';
import createHoldsRatioModalComponent from './components/holdInformation/main.js';
import createLanguageSelectionComponent from './components/language_selection/main.js';
import createMobileAccountMenuComponent from './components/mobile_account_menu/main.js';
import expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse from './util/dyslexic/expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse.js';
import {removeCarouselFunctionForOldAndroid} from './util/compatibility/removeCarouselFunctionality.js';
import HistoryEventTracker from './components/history_event_tracker/HistoryEventTracker';
import svgLoader from './util/svgLoader';
import CookieSettingsModal from './components/cookie_settings_modal/cookieSettingsModal';

/*
 * A function full of functions to be run on document ready
 */
const onDocumentReady = function() {

    const device = detectshun.browser();

    createLanguageSelectionComponent({
        el: document.querySelector('.js-languageSelection'),
        footerEl: document.querySelector('.js-languageSelectionFooter'),
        mobileEl: document.querySelector('.js-languageMobileSelection'),
        mobileFooterEl: document.querySelector('.js-languageMobileSelectionFooter')
    });

    // Create and attach holds ratio help modal
    createHoldsRatioModalComponent({
        el: document.querySelector('body')
    });

    // Create and attach desktop autocomplete component
    createComponentQuickSearchComponent({
        searchEl: document.querySelector('.js-desktopSearchContainer'),
        autocompletionsEl: document.querySelector('.js-quickSearchAutocompletionsDesktop'),
        toggleSearchEl: $('.desktop .js-toggleSearch'),
        options: {desktop: true}
    });

    // Create and attach mobile autocomplete component
    createComponentQuickSearchComponent({
        searchEl: document.querySelector('.js-mobileSearchContainer'),
        autocompletionsEl: document.querySelector('.js-quickSearchAutocompletionsMobile'),
        toggleSearchEl: $('.desktop .js-toggleSearch'),
        options: {mobile: true}
    });

    createMobileAccountMenuComponent({
        el: document.querySelector('.nav-container')
    });

    // Do expensive traversal for dyslexic if cookie set
    expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse();

    // Remove carousel functionality on old androids
    removeCarouselFunctionForOldAndroid(device);

    // new history tracker using cookies for auto scroll and back button redirect
    new HistoryEventTracker();

    svgLoader();

    if (window.OverDrive.showCookieSettingsModal) {
        new CookieSettingsModal({isDismissable: false}).render();
    }

    $('.cookieSettingsButton').on('click', () => {
        new CookieSettingsModal({isDismissable: true}).render();
    });
};

export default onDocumentReady;
